import { Card } from '@/components/ui/Card';
import { PILLARS } from '@/lib/content';

export function Pillars() {
  return (
    <section className="section" id="what-it-does">
      <div className="container">
        <div className="section__head">
          <span className="overline">What CareBee actually does</span>
          <h2>Four things no other app in this category puts together</h2>
        </div>

        <div className="grid grid--2">
          {PILLARS.map((pillar) => (
            <Card key={pillar.title}>
              <h3 className="card__title">{pillar.title}</h3>
              <p className="card__body">{pillar.body}</p>
              <p className="card__note">{pillar.note}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
